// Mock data for ThinkVerse.AI

import aiDevelopmentImg from "./assets/ai-development.jpg";
import aiAgentsImg from "./assets/ai-agents.jpg";
import productEngineeringImg from "./assets/product-engineering.png";
import consultingImg from "./assets/consulting.jpg";

export const services = [
  {
    id: 1,
    title: "AI Development",
    description: "Learning systems that adapt, grow, and empower your business through automation and innovation.",
    icon: "brain-circuit",
    imageUrl: aiDevelopmentImg
  },
  {
    id: 2,
    title: "AI Agents & Workflows",
    description: "Autonomous agents and enterprise automation pipelines designed for scalability.",
    icon: "workflow",
    imageUrl: aiAgentsImg
  },
  {
    id: 3,
    title: "Product Engineering",
    description: "Custom-built, high-performance software products engineered for the future.",
    icon: "code",
    imageUrl: productEngineeringImg
  },
  {
    id: 4,
    title: "Consulting & Strategy",
    description: "Strategic AI roadmaps and transformation consulting for sustainable innovation.",
    icon: "target",
    imageUrl: consultingImg
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Partnering with ThinkVerse.AI helped us 10x our efficiency with intelligent automation workflows.",
    author: "Riya S.",
    position: "CTO, EduNova Systems"
  },
  {
    id: 2,
    messages: [
      { id: 1, text: "Exactly what we needed!", sender: "client" },
      { id: 2, text: "ThinkVerse team understood our problem before we explained it.", sender: "client" },
      { id: 3, text: "Flawless execution and futuristic vision.", sender: "client" }
    ]
  }
];

export const blogs = [
  {
    id: 1,
    title: "How AI Agents Are Changing the Future of Work",
    category: "AI",
    excerpt: "Discover how autonomous AI agents are revolutionizing workplace productivity and decision-making.",
    date: "March 15, 2025"
  },
  {
    id: 2,
    title: "Designing Workflows That Think for You",
    category: "Innovation",
    excerpt: "Learn the principles behind creating intelligent automation workflows that adapt to your needs.",
    date: "March 10, 2025"
  },
  {
    id: 3,
    title: "Building Scalable AI Systems for Modern Enterprises",
    category: "AI",
    excerpt: "A comprehensive guide to architecting AI systems that grow with your business.",
    date: "March 5, 2025"
  }
];

export const technologies = [
  "React", "TypeScript", "Node.js", "Python", "Azure", "AWS", "TensorFlow", "PyTorch"
];

export const solutions = [
  "AI Agents", "Automation", "Software Development", "Consulting"
];

export const exploreLinks = [
  { name: "About", path: "#about" },
  { name: "Blog", path: "#blog" },
  { name: "Careers", path: "#careers" },
  { name: "Contact", path: "#contact" }
];

export const valueBullets = [
  { icon: "zap", text: "Future-Ready Code" },
  { icon: "search", text: "Data-Driven Design" },
  { icon: "brain", text: "AI-Infused Strategy" },
  { icon: "globe", text: "Enterprise Reliability" }
];
